import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, FlexBox, IconButton } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { memo, useCallback } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { ElevionCondition } from '../elevionCondition';
import { ElevionLogicalOp } from '../elevionLogicalOp';
import styles from './elevionConditionLogica.module.scss';
const emptyLeafNode = {
    comparator: '==',
    field: '',
    field_type: 'sfield',
    value: '',
};
const emptyLogicalNode = {
    logicalOp: 'AND',
    nodes: [emptyLeafNode],
};
/** Represents the field for managing options of a custom select attribute. */
export const ElevionConditionLogical = memo(function Options({ parentName, index, }) {
    const { control } = useFormContext();
    const nodeName = parentName !== undefined && index !== undefined
        ? `${parentName}.${index}`
        : 'visibility_condition';
    const nodeChildrenName = `${nodeName}.nodes`;
    const { fields, append, remove } = useFieldArray({
        control,
        name: nodeChildrenName,
    });
    const node = useWatch({
        control,
        name: nodeName,
    });
    const addNewBlock = useCallback(() => {
        append(emptyLogicalNode, { shouldFocus: false });
    }, [append]);
    const addNewRule = useCallback(() => {
        append(emptyLeafNode, { shouldFocus: false });
    }, [append]);
    /** Handles the event for when an option is removed. */
    const removeRule = useCallback((index) => {
        remove(index);
    }, [remove]);
    return (_jsx(FlexBox, Object.assign({ flexDirection: "column", padding: "200", width: "100%", className: classnames({ [styles.logicalBlock]: parentName }) }, { children: fields.map((field, childIndex) => {
            const isNotLast = childIndex < fields.length - 1;
            const isLast = childIndex === fields.length - 1;
            const isNotLogicalNotOp = node.logicalOp !== 'NOT';
            const isFirst = childIndex === 0;
            return (_jsxs(Box, { children: [_jsxs(FlexBox, { children: [_jsx(FlexBox, Object.assign({ flex: "1 1 auto" }, { children: _jsx(ElevionCondition, { index: childIndex, parentName: nodeChildrenName }) })), _jsx(FlexBox, Object.assign({ flex: "0 0 auto", alignItems: "flex-start", padding: "0 200" }, { children: _jsx(Box, { children: _jsx(IconButton, Object.assign({ disabled: isFirst && isLast, icon: "trash", variant: "secondary", onClick: () => removeRule(childIndex) }, { children: "Remove" })) }) }))] }), isNotLast && (_jsx(ElevionLogicalOp, { activeOp: node.logicalOp, readOnly: childIndex !== 0, parentName: nodeName })), isLast && isNotLogicalNotOp && (_jsxs(FlexBox, Object.assign({ margin: "200 0 0 200" }, { children: [_jsx(Box, Object.assign({ margin: "0 200 0 0" }, { children: _jsx(Button, Object.assign({ variant: "secondary", onClick: addNewRule }, { children: "Add rule" })) })), _jsx(Box, { children: _jsx(Button, Object.assign({ variant: "secondary", onClick: addNewBlock }, { children: "Add block" })) })] })))] }, field.id));
        }) })));
});
